import { KeycloakToken } from './keycloak-token.ts';
import { Provide } from '../ioc-container/ioc-container.ts';

@Provide()
export class JwtDecoder {
	decode(jwt: string): KeycloakToken {
		const payload = jwt.split('.')[1];

		return JSON.parse(this.fromBinary(payload));
	}

	// Source: https://stackoverflow.com/a/30106551
	// Decoding base64 ⇢ UTF-8
	private fromBinary(str: string): string {
		const sanitizedString = str.replace(/-/g, '+').replace(/_/g, '/');
		return decodeURIComponent(
			atob(sanitizedString)
				.split('')
				.map(function (c) {
					return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
				})
				.join(''),
		);
	}
}
